import { Component, OnInit } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { SystemSetting } from '../../models/system-setting/system-setting.model';
import { SystemSettingService } from '../../services/system-settings/system-setting.service';

@Component({
  selector: 'app-edit-setting',
  templateUrl: './edit-setting.component.html',
  styleUrls: ['./edit-setting.component.scss']
})
/** edit-setting component*/
export class EditSettingComponent {
  systemSetting = new SystemSetting();
  /** edit-setting ctor */
  constructor(private _avRoute: ActivatedRoute,
    private systemSettingService: SystemSettingService, private _router: Router) {
    if (this._avRoute.snapshot.params["id"]) {
      this.getSystemSettingsById(this._avRoute.snapshot.params["id"]);
    }
  }

  getSystemSettingsById(id: string) {
    this.systemSettingService.GetSystemSettingsById(id).subscribe(
      data => {
        this.systemSetting = data;
        if (this.systemSetting.defaultCurrency == null) {
          this.systemSetting.defaultCurrency = "";
        }
        if (this.systemSetting.currencySymbol == null) {
          this.systemSetting.currencySymbol = "";
        }
        if (this.systemSetting.defaultTimezone == null) {
          this.systemSetting.defaultTimezone = "";
        }
        if (this.systemSetting.dateFormat == null) {
          this.systemSetting.dateFormat = "";
        }
        if (this.systemSetting.timeFormat == null) {
          this.systemSetting.timeFormat = "";
        }
      }
    )
  }
  onSubmit() {
    this.systemSettingService.UpdateSystemSetting(this.systemSetting);
  }
}



// WEBPACK FOOTER //
// ./src/app/system-setting-component/edit-setting/edit-setting.component.ts